export const DEFAULT_ATTACHMENT_TYPE = 'case_file'
export const DEFAULT_TEMPLATE_TARGET = 'case_file'

export const DEFAULT_LANGUAGE = 'de'
export const DEFAULT_TONALITY = 'no_tonality'
export const DEFAULT_COUNTRY = 'universal'
export const MANUAL_SEND_GROUP = 'manual'

export const DEFAULT_PAIR_ENVIRONMENT = 'nl'
export const OLD_SLUG_LENGTH = 12
export const SLUG_NUMBER_TO_ENVIRONMENT_MAP = {
  '101': 'de',
  '102': 'at',
  '103': 'ch',
  '104': 'nl',
  '105': 'se',
  '106': 'pl',
  '107': 'no'
}

export const DEFAULT_PREVIEW_FILE_NAME = 'preview.pdf'

export const PLAIN_TEXT_TEMPLATE_KINDS = ['sms', 'rcs', 'plain']
export const TEMPLATE_WITHOUT_CONTENT_FIELD_KINDS = ['mjml', 'html']

export const ATTACHMENT_URL_VARIABLE = '{% attachment_file_url {id} %}'
export const DEBTOR_UUID_VARIABLE = '{{ primary_debtor.uuid }}'
export const DOMAIN_VARIABLE = '{{ domain }}'

export const TREE_KINDS_WITH_ITEMS_TO_SORT = [
  'variables',
  'snippets',
  'images',
  'links'
]

export const SNIPPET_TEMPLATE_KINDS = ['plain', 'mjml', 'html']

export const FALLBACK_TEMPLATE_KIND_MAPPER: Record<string, string> = {
  rcs: 'sms'
}

export const TEXT_CONTENT_TYPE = 'text'
export const CARD_CONTENT_TYPE = 'card'
export const CONTENT_TYPES = [TEXT_CONTENT_TYPE, CARD_CONTENT_TYPE]
export const CARD_CONTENT_TYPE_KINDS = ['rcs']

export const RCS_ACTION_OPEN_URL = 'OPEN_URL'
export const RCS_ACTION_DIAL_PHONE = 'DIAL_PHONE'
export const RCS_ACTION_TYPES = [RCS_ACTION_OPEN_URL, RCS_ACTION_DIAL_PHONE]

export const RICH_CARD_MAX_BUTTONS = 4
export const RICH_CARD_MAX_RCS_ACTIONS = 11
export const RICH_CARD_MAX_TITLE_LENGTH = 200
export const RICH_CARD_MAX_DESCRIPTION_LENGTH = 2000
export const RICH_CARD_MAX_ACTION_TEXT_LENGTH = 25
export const RICH_CARD_MAX_ACTION_URL_LENGTH = 2048
export const RICH_CARD_MAX_PHONE_NUMBER_DIGITS = 15

// Both derive from which list an action belongs to, so they cannot drift apart.
export const RICH_CARD_ACTION_ID_PREFIX = {
  buttons: 'rich-card-button',
  rcsActions: 'rich-card-rcs-action'
}
export const RICH_CARD_ACTION_LOCALE_ROOT = {
  buttons: 'shared.template_form.rich_card.buttons',
  rcsActions: 'shared.template_form.rich_card.rcs_actions'
}

// Mirrors Image::MIME_TYPES.
export const RICH_CARD_IMAGE_EXTENSIONS = ['jpeg', 'jpg', 'png', 'gif']
